import { defineComponent as _defineComponent } from 'vue'
import {Currency} from "@/models/currency";
import {useUserStore} from "@/store/user.store";
import {LoginTypeEnum, useUserServiceStore} from "@/store/userService.store";
import {addDotsInsideTooLongString} from "@/utils/string-formatter";
import Dialog from "primevue/dialog";
import IconComponent from "@/components/features/IconComponent.vue";
import TooltipComponent from "@/components/TooltipComponent.vue";
import Button from "primevue/button";
import {useRouter} from "vue-router";
import {useToast} from "vue-toastification";
import {usePublicSalesStore} from "@/store/publicSales.store";
import {useTransactionContextStore} from "@/store/transactionContext.store";
import {useI18n} from "vue-i18n";
import {computed, ref} from "vue";
import {useConfigurationStore} from "@/store/configuration.store";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderModal',
  emits: ["onKycStart", 'onAcceptTerms',
  'onProvideClaimerAddress', 'onProvideSourceAddress', 'onConnect'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();


const emit = __emit;

const router = useRouter();
const toast = useToast();
const publicSaleStore = usePublicSalesStore();
const transactionContextStore = useTransactionContextStore();

const i18n = useI18n();

// const loginPopupStatus = ref(false);

// const connectMetamask = () => {
//   useUserStore().connectMetamask();
// };
const isLoggedIn = computed(() =>{
  return useUserStore().isLoggedIn;
});
function showApprovalModalFunc(){
  emit('onAcceptTerms');
}

const claimerAddress = computed(() => {
  return useUserServiceStore().claimAddress;
});
const sourceAddress = computed(() => {
  return useUserServiceStore().ethereumAddress;
});

const isTermsAccepted = computed(() =>{
  return useUserServiceStore().isTermsAccepted;
});

const isKycLevelRequired = computed(() => {
  return useUserServiceStore().kycLevel >= transactionContextStore.getRequiredKycLevel;
});

const onConfirm = () => {
  if(useUserServiceStore().loginType == LoginTypeEnum.NONE) {
    router.push({name: 'signIn'});
  } else {
    transactionContextStore.orderModalVisible = true;
    publicSaleStore.reserveTokens(useConfigurationStore().config.currentPublicSaleRoundId,Number(transactionContextStore.getAmountToBuyUc4e), onSuccess, onFail);
  }
};

const onSuccess = (orderId: number) => {
  transactionContextStore.setOrderId(orderId);
  transactionContextStore.orderModalVisible = false;
  usePublicSalesStore().fetchTokenReservations();
  toast.success('Tokens reserved successfully');
  if(transactionContextStore.paymentCurrency != Currency.STABLE) {
    router.push({name: 'fiatPaymentConfirmation'});
  } else {
    router.push({name: 'paymentConfirmation'});
  }
};

const onFail = () => {
  // let toastMessage = 'An error occurred \n';
  // if (errorMessage) toastMessage+=errorMessage;
  // toast.error(toastMessage);
};

const onKycStart = () => {
  emit('onKycStart');
};

function provideClaimerAddress() {
  emit('onProvideClaimerAddress');
}
function provideSourceAddress(){
  emit('onProvideSourceAddress');
}


const canConfirmOrder = computed(() => {
  const isSourceAddressRequired = transactionContextStore.paymentCurrency == Currency.STABLE;
  if(isSourceAddressRequired) {
    return isKycLevelRequired.value && isTermsAccepted.value && claimerAddress.value != undefined && sourceAddress.value != undefined;
  }
  return isKycLevelRequired.value && isTermsAccepted.value && claimerAddress.value != undefined;
});



const __returned__ = { emit, router, toast, publicSaleStore, transactionContextStore, i18n, isLoggedIn, showApprovalModalFunc, claimerAddress, sourceAddress, isTermsAccepted, isKycLevelRequired, onConfirm, onSuccess, onFail, onKycStart, provideClaimerAddress, provideSourceAddress, canConfirmOrder, get Currency() { return Currency }, get useUserServiceStore() { return useUserServiceStore }, get addDotsInsideTooLongString() { return addDotsInsideTooLongString }, get Dialog() { return Dialog }, IconComponent, TooltipComponent, get Button() { return Button } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})